import {
    useWatch,
    type Control,
    type FieldValues,
    type Path
} from 'react-hook-form';
import type { IntlShape } from 'react-intl';
import { recommendedWarning } from './recommendedWarning';

/**
 * The recommended-empty hint for a REGISTERED (uncontrolled) field, which —
 * unlike the Controller-driven ones — has no value to hand its renderer.
 *
 * A component, and the only one in this module, so that the subscription that
 * decides whether the hint shows belongs to the HINT. Read through the form's
 * `watch` instead, every keystroke in any soft-required field re-rendered the
 * whole fullscreen form to decide whether one small icon was still there. It is
 * also the one API of react-hook-form the React Compiler cannot memoize (see
 * react-hooks/incompatible-library).
 */
export function RecommendedFieldWarning<Values extends FieldValues>({
    control,
    name,
    intl,
    bare
}: {
    control: Control<Values>;
    name: Path<Values>;
    intl: IntlShape;
    /** Inside an Autocomplete's own adornment container — see EmptyFieldWarning. */
    bare?: boolean;
}) {
    const value = useWatch({ control, name });
    return recommendedWarning(intl, !value, bare) ?? null;
}
